export default function cancelarAgendamentoPublicDTO({
      DATA, 
      IDHORARIO, 
      MOTIVO,
      IDCADASTRO, 
      IDAGENDAMENTO
    
    }) {
  return {
      DATA, 
      IDHORARIO, 
      MOTIVO,
      IDCADASTRO, 
      IDAGENDAMENTO
  };
}